.loginGlobal {
	background: #f5f5f5;
	/*IMPORTANTE*/
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;

	.main {
		background-color: #fafafa;
		padding: 4em;
		padding-left: 2em;
		padding-right: 2em;
		border-radius: 10px;
		max-width: 25em;

		.header {
			text-align: center;
		}

		.form {
			background-color: white;
			padding: 1em;
			margin-top: 2em;
			border-radius: 10px;
			max-width: 21em;

			.title {
				text-align: center;
				color: #7fb02f;
				margin-bottom: 1em;
				font-weight: 400;
			}

			.inputContent {
				padding-bottom: 1em;

				.input {
					width: 100%;
					font-size: 14px;
					padding: 10px 10px 10px 5px;
					border: none;
					border-bottom: 1px solid #cfd2d8;
				}
			}
		}

		.submit {
			margin-top: 1.5em;
			border: 1px solid #82be45;
			border-radius: 7px;
			padding: 5px;
			text-align: center;
			background: linear-gradient(45deg, #82be45, #9ccc59);
			cursor: pointer;
			color: white;
		}

		.forgotPassword {
			margin-top: 1em;
			text-align: center;
			cursor: pointer;
			color: #979dac;
			text-decoration-line: underline;
		}
	}
}
